import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;

  cursor: pointer;
`;

export const CaretDown = styled.div`
  margin-left: 10px;
`;
